import {BaseContainerModel} from "../../base-container.model";
import { bl_wf_md_process_ext_RowClass, bl_wf_md_process_hdr_RowClass, bl_wf_md_process_hdr_RowInterface, bl_wf_md_process_line_RowClass, bl_wf_md_transition_RowClass, bl_wf_md_transition_RowInterface} from "../../../dbschema";

export class WfMdTransitionContainerModel extends BaseContainerModel{
  bl_wf_md_transition: bl_wf_md_transition_RowInterface = new bl_wf_md_transition_RowClass();
}
